/*=========================================================================================
  File Name: i18n.js
  Description: Thiết lập localize
  ----------------------------------------------------------------------------------------
  Author: PDKIEN
  Author URL: https://misa.com.vn
==========================================================================================*/

import { createI18n } from "vue-i18n";
import i18nData from "./i18nData";

export default createI18n({
  legacy: false,
  locale: "vi", // set default locale
  fallbackLocale: "vi",
  messages: i18nData,
});
